import { ref } from 'vue'

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

const _deferredPrompt = ref<BeforeInstallPromptEvent | null>(null)

export const isInstallable = ref(false)
export const isInstalled = ref(false)

if (typeof window !== 'undefined') {
  const mq = window.matchMedia('(display-mode: standalone)')
  if (mq.matches || (navigator as Record<string, unknown>).standalone === true) {
    isInstalled.value = true
  }

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    _deferredPrompt.value = e as BeforeInstallPromptEvent
    isInstallable.value = true
  })

  window.addEventListener('appinstalled', () => {
    isInstalled.value = true
    isInstallable.value = false
    _deferredPrompt.value = null
  })
}

export async function promptInstall(): Promise<boolean> {
  if (!_deferredPrompt.value) return false
  const prompt = _deferredPrompt.value
  await prompt.prompt()
  const { outcome } = await prompt.userChoice
  _deferredPrompt.value = null
  if (outcome === 'accepted') {
    isInstalled.value = true
    isInstallable.value = false
    return true
  }
  return false
}
